/**
 * COYN-1507: shared enums of the troubleshooting (participant timeline) API.
 * Source of truth: COYN-1507 shared contract §2. Values must match the backend
 * exactly — extend, never rename.
 */

export enum TimelineOutcomeEnum {
  OK = "OK",
  SKIPPED = "SKIPPED",
  FAILED = "FAILED",
  INFO = "INFO",
}

export enum TimelineLaneEnum {
  SESSION_APP = "SESSION_APP",
  PERMISSIONS_TOKEN = "PERMISSIONS_TOKEN",
  GEOFENCE = "GEOFENCE",
  VALIDATION = "VALIDATION",
  NOTIFICATIONS = "NOTIFICATIONS",
}

/** Lanes in the order they are drawn on the swimlane. */
export const TIMELINE_LANES: TimelineLaneEnum[] = [
  TimelineLaneEnum.SESSION_APP,
  TimelineLaneEnum.PERMISSIONS_TOKEN,
  TimelineLaneEnum.GEOFENCE,
  TimelineLaneEnum.VALIDATION,
  TimelineLaneEnum.NOTIFICATIONS,
];

/**
 * Known journey step keys per journey kind (contract §4 / §6.4). The UI
 * renders `ValidationJourney.steps` generically in the order the API sends
 * them; these lists only type the keys and keep the i18n labels complete.
 */
export const VALIDATION_JOURNEY_STEP_KEYS = [
  "EXIT",
  "EVALUATION",
  "TEST_RESULT",
  "NOTIFICATION",
  "PROVIDER_DELIVERY",
  "RECEIVED_CLICKED",
  "STARTED_SUBMITTED",
  "RESULT",
] as const;

/**
 * Contract §11.3.4: device-side steps that now open a VALIDATION_REQUEST
 * journey (DEVICE_DETECTED → HTTP_DELIVERY → EXIT → …).
 */
export const DEVICE_JOURNEY_STEP_KEYS = [
  "DEVICE_DETECTED",
  "HTTP_DELIVERY",
] as const;

/** Contract §11.3.4: journey of an EXIT seen only on the device. */
export const DEVICE_ONLY_JOURNEY_PREFIX = "device:";

export const ADDRESS_SYNC_JOURNEY_STEP_KEYS = [
  "ADDRESS_CHANGE",
  "NOTIFICATION",
  "PROVIDER_DELIVERY",
  "RECEIVED_CLICKED",
  "SESSION",
  "SYNC_RESULT",
  "CONFIRMED",
] as const;

export const JOURNEY_KINDS = [
  "VALIDATION_REQUEST",
  "FIRST_VALIDATION",
  "ADDRESS_SYNC",
] as const;

/** Session state derived by the backend (contract §6.1). */
export const SESSION_STATES = ["ACTIVE", "ENDED", "STALE", "UNKNOWN"] as const;

/** Contract §11.3.5: geofence sync state of the participant's device. */
export const GEOFENCE_SYNC_STATES = [
  "OK",
  "MISCONFIGURED",
  "NOT_STARTED",
  "UNKNOWN",
] as const;
